import React, { FC } from 'react';
import { OverView } from 'models/workflow-step';
import { useTranslation } from 'react-i18next';
import { Box, Divider, Link, Paper, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

type StepBoxProps = {
    step: OverView;
};
const StepBox: FC<StepBoxProps> = ({ step }: StepBoxProps) => {
    const { t: translate } = useTranslation(['workflow', 'orders']);

    return (
        <Link
            component={RouterLink}
            to={`/workflow/orders?id=${step.stepId}&name=${step.name}`}
            color="inherit"
            underline="none"
        >
            <Paper
                sx={{
                    height: '100%',
                    borderLeft: step.pausedOrders ? '3px solid' : 'none',
                    borderColor: step.pausedOrders ? 'warning.light' : '',
                }}
            >
                <Box p={1}>
                    <Typography variant="h4">{step.name}</Typography>
                    <Box my={1}>
                        <Divider />
                    </Box>
                    <Box>
                        {step.noOfOrders} {translate('ORDERS')}
                    </Box>
                    <Box>
                        {step.noOfConstructions} {translate('CONSTRUCTIONS')}
                    </Box>
                    <Box>
                        {step.noOfActions} {translate('workflow:ACTIONS')}
                    </Box>
                    {step.pausedOrders ? (
                        <Box>
                            <Typography
                                variant="caption"
                                sx={{
                                    color: 'warning.main',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    fontSize: '1rem',
                                }}
                            >
                                {step.pausedOrders} {translate('workflow:PAUSED')} {translate('ORDERS')}
                            </Typography>
                        </Box>
                    ) : undefined}
                </Box>
            </Paper>
        </Link>
    );
};

export default StepBox;
